export const ApplicationEN = {
    "leaveReason":"Leave Reason",
    "absenceReason":"Absence Reason",
    "inoutReason":"Inout Reason",
    "missionsReason":"Missions Reason",
    "vehicleMissionsReason":"Vehicle Missions Reason",
    "feesMissionsReason":"Fees Missions Reason",
    "flexibleReason":"Flexible Reason",
    "resignationReason":"Resignation Reason",
}